module.exports = __webpack_public_path__ + "static/img/order_active@2x.a41c980e.png";